import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { Lock, LockPolicy } from "../types/lock";

const c = initContract();

export const lockContract = c.router(
    {
        getLocks: {
            method: "GET",
            path: "/",
            query: z.object({
                entityIds: z.array(z.coerce.number()),
            }),
            responses: {
                200: c.type<{ locks: Lock[] }>(),
                404: ErrorMessageSchema,
            },
        },
        getLock: {
            method: "GET",
            path: "/:entityId",
            pathParams: z.object({
                entityId: z.union([z.coerce.number(), z.string().uuid()]),
            }),
            responses: {
                200: c.type<{ locks: Lock[] }>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateLock: {
            method: "POST",
            path: "/:entityId",
            pathParams: z.object({
                entityId: z.union([z.coerce.number(), z.string().uuid()]),
            }),
            responses: {
                201: c.type<{ locks: Lock[] }>(),
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
            body: z.object({
                date: z.string().nullable(),
                policy: z.nativeEnum(LockPolicy),
            }),
        },
    },
    {
        pathPrefix: "/lock",
    },
);
